// extracted by mini-css-extract-plugin
export default {"bannerContainer":"d3Ofc","bannerImage":"fvBzG","bannerContent":"KBdjZ","bannerContentWithText":"J0_7Z","description":"V5gVX","onlyDescription":"wljsI","title":"thh4x"};